import { type Meta } from '../types/docs';
import { AGENT_ONBOARDING_ROLE_META_PARAM } from './agentOnboardingAnalytics';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'The "First, what do you do?" question is answered',
  name: 'agent_onboarding_role_selected',
  params: [WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM, AGENT_ONBOARDING_ROLE_META_PARAM],
};

export default META;
